
var locations = getLocations();
var map;

// get office locations from HTML
// and return an array of arrays with the information
// in the following positions
// [description, latitude, longitude, zIndex]
function getLocations() {
    var locations = [], place = [], $element;

    $('.office-link').map(function (index, el) {
        $element = $(el);

        place.push($element.data('office'));
        place.push($element.data('region'));
        place.push($element.data('lat'));
        place.push($element.data('lng'));
        place.push($element.data('replace'));
        place.push($element.data('id'));
        locations.push(place);
        place = [];
    });

    return locations;
}


function initMap() {


    if ($('#office-map').length) {


        map = new google.maps.Map(document.getElementById('office-map'), {

            center: { lat: 0, lng: 0 },
            zoom: 2,
            mapTypeControlOptions: {
                mapTypeIds: [
                    //google.maps.MapTypeId.ROADMAP,
                    //google.maps.MapTypeId.SATELLITE
                ]
            }//,
            //styles: [
            //    {
            //        "elementType": "geometry",
            //        "stylers": [
            //            {
            //                "color": "#f5f5f5"
            //            }
            //        ]
            //    },
            //    {
            //        "elementType": "labels.icon",
            //        "stylers": [
            //            {
            //                "visibility": "off"
            //            }
            //        ]
            //    },
            //    {
            //        "elementType": "labels.text.fill",
            //        "stylers": [
            //            {
            //                "color": "#616161"
            //            }
            //        ]
            //    },
            //    {
            //        "elementType": "labels.text.stroke",
            //        "stylers": [
            //            {
            //                "color": "#f5f5f5"
            //            }
            //        ]
            //    },
            //    {
            //        "featureType": "administrative.land_parcel",
            //        "elementType": "labels.text.fill",
            //        "stylers": [
            //            {
            //                "color": "#bdbdbd"
            //            }
            //        ]
            //    },
            //    {
            //        "featureType": "poi",
            //        "elementType": "geometry",
            //        "stylers": [
            //            {
            //                "color": "#eeeeee"
            //            }
            //        ]
            //    },
            //    {
            //        "featureType": "poi",
            //        "elementType": "labels.text.fill",
            //        "stylers": [
            //            {
            //                "color": "#757575"
            //            }
            //        ]
            //    },
            //    {
            //        "featureType": "poi.park",
            //        "elementType": "geometry",
            //        "stylers": [
            //            {
            //                "color": "#e5e5e5"
            //            }
            //        ]
            //    },
            //    {
            //        "featureType": "poi.park",
            //        "elementType": "labels.text.fill",
            //        "stylers": [
            //            {
            //                "color": "#9e9e9e"
            //            }
            //        ]
            //    },
            //    {
            //        "featureType": "road",
            //        "elementType": "geometry",
            //        "stylers": [
            //            {
            //                "color": "#ffffff"
            //            }
            //        ]
            //    },
            //    {
            //        "featureType": "road.arterial",
            //        "elementType": "labels.text.fill",
            //        "stylers": [
            //            {
            //                "color": "#757575"
            //            }
            //        ]
            //    },
            //    {
            //        "featureType": "road.highway",
            //        "elementType": "geometry",
            //        "stylers": [
            //            {
            //                "color": "#dadada"
            //            }
            //        ]
            //    },
            //    {
            //        "featureType": "road.highway",
            //        "elementType": "labels.text.fill",
            //        "stylers": [
            //            {
            //                "color": "#616161"
            //            }
            //        ]
            //    },
            //    {
            //        "featureType": "road.local",
            //        "elementType": "labels.text.fill",
            //        "stylers": [
            //            {
            //                "color": "#9e9e9e"
            //            }
            //        ]
            //    },
            //    {
            //        "featureType": "transit.line",
            //        "elementType": "geometry",
            //        "stylers": [
            //            {
            //                "color": "#e5e5e5"
            //            }
            //        ]
            //    },
            //    {
            //        "featureType": "transit.station",
            //        "elementType": "geometry",
            //        "stylers": [
            //            {
            //                "color": "#eeeeee"
            //            }
            //        ]
            //    },
            //    {
            //        "featureType": "water",
            //        "elementType": "geometry",
            //        "stylers": [
            //            {
            //                "color": "#c9c9c9"
            //            }
            //        ]
            //    },
            //    {
            //        "featureType": "water",
            //        "elementType": "labels.text.fill",
            //        "stylers": [
            //            {
            //                "color": "#9e9e9e"
            //            }
            //        ]
            //    }
            //]

        });


        //***********************Custom map scripts*******************************//

        //set the zoom level to a variable
        var zoom = map.getZoom();

        //Set variable to write to when an info window has been set
        var activeInfoWindow;

        //Set the variable for infoWindow
        var infowindow = new google.maps.InfoWindow({
            content: ""
        });

        //Set an empty
        var regions = [];
        var markers = [];

        for (i = 0; i < locations.length; i++) {

            var officename = locations[i][0];
            var officereplaced = locations[i][4];
            var region = locations[i][1];
            var lat = locations[i][2];
            var lng = locations[i][3];
            var officeid = locations[i][5];
            var image = { url: '/assets/img/pin.png' }
            var position = new google.maps.LatLng(lat, lng);
            var hq = "";
            var regionFull = "";
            //if (officename == "Chester") {
            //    hq = " (UK HQ)";
            //}

            var marker = new google.maps.Marker({
                position: position,
                map: map,
                icon: image,
                title: officename,
                region: region,
                replaced: officereplaced,
                zIndex: locations[i][3]
            });

            if (regions.includes(region)) {
                //nothing
            }
            else {
                if (region === "USA") {
                    regionFull = "North America";
                }
                else if (region === "EMEA") {
                    regionFull = "Europe & Middle East";
                }
                
                else if (region === "APAC") {
                    regionFull = "APAC";
                }


                //if (region != '') {
                //    $(".office-accordion .panel-group").append('<div class="panel panel-light"><div class="panel-heading collapsed" role="tab" id="heading-' + region + '" data-region="' + region + '" data-toggle="collapse" data-parent="#accordion" href="#' + region + '" aria-expanded="false" aria-controls="collapse-' + region + '"><h4 class="panel-title">' + region + '<span class="panel-icon"><span></span></span></h4><p>' + regionFull + '</p></div><div id="' + region + '" class="panel-collapse collapse" role="tabpanel" aria-labelledby="collapse-' + region + '" style=""><div class="panel-body"><ul></ul></div></div></div>');
                //    regions.push(locations[i][1]);
                //}
                if (region !== '') {
                    $(".office-list").append('<div class="col-md-4"><h4 class="text-center">' + region + '<span class="panel-icon"><span></span></span></h4><p>' + regionFull + '</p></div><div id="' + region + '" class="panel-collapse" role="tabpanel" aria-labelledby="collapse-' + region + '" style=""><div class="panel-body"><ul></ul></div></div>');
                    regions.push(locations[i][1]);
                }
            }

            if (region !== '') {
                $('#office-' + region +" ul").append('<li><p></p><span class="office-link" data-office-id="' + i + '" data-office="' + officename + '" data-replaced="' + officereplaced + '" data-lat="' + lat + '" data-lng="' + lng + '">' + officename + hq + '</span></li>');
                $('#' + region + " .panel-body ul").append('<li><span class="office-link" data-office-id="' + i + '" data-office="' + officename + '" data-replaced="' + officereplaced + '" data-lat="' + lat + '" data-lng="' + lng + '">' + officename + hq + '</span></li>');
            }
            $(".panel-heading").on("click", function () {
                $('.panel').not(this).removeClass('active');
                $(this).closest('.panel').addClass('active');

                var region = $(this).data('region');
                $('#' + region).collapse('show');
                $('.panel-collapse').not('#' + region).collapse('hide');
            });

            //Accordion actions
            $("button.office-link").on("click", function () {


                var officeData = $(this).data('office');
                var officeReplaced = $(this).data('replaced');


                //Fade the accordion
                //$('.office-close').attr("data-office", officeReplaced);
                //$('.office-card').removeClass('active');
                //$('.office-card.' + officeReplaced).addClass('active');
                //$('.office-accordion').hide();
                //$('.office-close').fadeIn();
                //$('.office-card').hide();
                //$('.' + officeReplaced).fadeTo('', 1);

                var LatLng = new google.maps.LatLng($(this).data('lat'), $(this).data('lng'));

                if (activeInfoWindow) { activeInfoWindow.close(); }

                activeInfoWindow = infowindow;
                infowindow.close(map);
                infowindow.setContent(officeData);
                infowindow.setPosition(LatLng);
                infowindow.setOptions({
                    pixelOffset: new google.maps.Size(0, -36)
                });

                //infowindow.open(map);

                if (map.getZoom() !== 6) {
                    map.setZoom(6)
                }

                map.panTo(LatLng);

            });

            ////Close action
            //$(".office-close").click(function () {
            //    var office = $(this).attr("data-office");
            //    $(this).hide();
            //    $(".office-card").hide();
            //    $('.office-close').attr('data-office', '');
            //    $('.office-accordion').show();
            //    //$('.office-accordion').css('opacity', '1');
            //    $('.office-card').removeClass('active');
            //    isAnimating = false;
            //});

            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                return function () {
                    var officename = this.title;
                    var namereplaced = this.replaced;
                    var region = this.region;


                    $('#collapse-' + namereplaced).collapse('show');
                    


                    if (activeInfoWindow) {
                        activeInfoWindow.close();
                    }

                    //Set the offset to 0
                    infowindow.setOptions({
                        pixelOffset: new google.maps.Size(0, 0)
                    });

                    //Open the window
                    infowindow.open(map);
                    //Set the active window
                    activeInfoWindow = infowindow;

                    infowindow.setContent(officename);
                    infowindow.open(map, marker);

                }
            })(marker, i));

        } // end of for loop


        google.maps.event.addListener(map, 'zoom_changed', function () {
            zoomLevel = map.getZoom();
            //console.log(zoomLevel);
        });
        google.maps.event.addListener(map, 'bounds_changed', onBoundsChanged);


        //function to check if full screen is active
        function onBoundsChanged() {
            if ($(map.getDiv()).children().eq(0).height() == window.innerHeight && $(map.getDiv()).children().eq(0).width() == window.innerWidth) {
                //console.log( 'FULL SCREEN' );
            }
            else {
                //console.log ('NOT FULL SCREEN');
            }
        }

    }
}//end of init

